<!-- 商品主数据禁用 -->
<template>
  <div class="goodsDetail">
    <!-- tab页 -->
    <el-tabs class="addGoodsTabs" type="border-card">
      <!-- 物产化工主数据 -->
      <el-tab-pane :label="$t('goods.tab.wchgData')">
        <wchg-data
          ref="wchgData"
          :addFlag="false"
          :isEdit="false"
          :goodsDetail="goodsDetail"
          :extendList="extendList"
          v-if="goodsDetail && dictList.unitOptions.length > 0"
          :dictList="dictList"
          @updateChoosenDetailStatus="updateChoosenDetailStatus"
        />
      </el-tab-pane>
      <!-- 公司自有数据 -->
      <el-tab-pane :label="$t('goods.tab.companyData')">
        <company-data
          ref="companyData"
          :isEdit="false"
          :extendList="extendList"
          :goodsDetail="goodsDetail"
          :dictList="dictList"
          :firstTabData="firstTabData"
          v-if="
            goodsDetail &&
            dictList.unitOptions.length > 0 &&
            dictList.costCourseOptions.length > 0 &&
            dictList.incomeCourseOptions.length > 0
          "
        />
      </el-tab-pane>
      <!-- 系统映射表 -->
      <el-tab-pane :label="$t('goods.tab.mappingData')">
        <mapping-data
          ref="mappingData"
          :isEdit="false"
          :callLogsData="[]"
          :dataMapping="goodsDetail.systemMaps || []"
          v-if="goodsDetail"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 底部按钮 -->
    <div class="fixed-bottom-btnList" v-if="this.goodsDetail">
      <el-button
        class="saveBtn"
        type="primary"
        :disabled="!this.canForbidAllFlag"
        @click="updateAllDetailStatus()"
        >{{ this.$t('goods.button.forbidAll') }}</el-button
      >
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import wchgData from './components/wchgData'; // 物产化工主数据
  import companyData from './components/companyData'; // 公司自有数据
  import mappingData from './components/mappingData'; // 系统映射表
  import API from '@/api/masterData/goods';

  export default {
    name: 'forbidenGoods',
    components: {
      wchgData,
      companyData,
      mappingData,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
        stateDictList(state) {
          if (state.dict.dictList.length > 10) {
            this.dictList.unitOptions = state.dict.dictList.find(
              (it) => it.dictType == 'basic_unit'
            ).dictList;
            this.dictList.incomeCourseOptions = state.dict.dictList.find(
              (it) => it.dictType == 'income_course'
            ).dictList;
            this.dictList.costCourseOptions = state.dict.dictList.find(
              (it) => it.dictType == 'cost_course'
            ).dictList;
            this.$forceUpdate();
          }
        },
      }),
      propsGoodsId() {
        // 获取路由参数 => 合作伙伴详情
        return this.$route.query.propsGoodsId;
      },
    },
    watch: {
      stateDictList(newV) {
        if (newV.length > 10) {
          this.dictList.unitOptions = this.dict.dictList.find(
            (it) => it.dictType == 'basic_unit'
          ).dictList;
          this.dictList.incomeCourseOptions = this.dict.dictList.find(
            (it) => it.dictType == 'income_course'
          ).dictList;
          this.dictList.costCourseOptions = this.dict.dictList.find(
            (it) => it.dictType == 'cost_course'
          ).dictList;
          this.$forceUpdate();
        }
      },
    },
    created() {
      this.getDetail();

      //this.getCompanyInfo()//获取公司信息
    },
    data() {
      return {
        goodsDetail: null,
        firstTabData: {
          dataAuthTableData: [],
          baseData: {},
        },
        extendList: [], //扩展公司信息 同时也是数据权限
        companyOptions: [], //公司下拉
        dictList: {
          unitOptions: [],
          groupCategoryOptions: [],
          incomeCourseOptions: [],
          costCourseOptions: [],
        }, //所有数据字典结果
        canForbidAllFlag: true, //是否展示 禁用所有按钮
      };
    },
    mounted() {
      // console.log(this.userInfo)
    },
    methods: {
      //获取数据权限表格数据
      getCompanyInfo() {
        //判断是否是新增
        if (this.$route.name == 'addGoods') {
          //新增
          let extendList = [];
          let obj = {
            extendCompanyCode: this.userInfo.companyCode,
            extendCompanyName: this.userInfo.companyName,
            list: [],
          };
          extendList.push(obj);
          this.extendList = extendList;
        } else {
          this.extendList = this.goodsDetail.extendList;
        }
      },

      // 获取商品主数据详情
      getDetail() {
        const params = {
          id: this.propsGoodsId,
        };
        this.$axios
          .post(API.PRODUCT_DETAIL, params)
          .then((res) => {
            if (res.data.code === 0) {
              this.goodsDetail = res.data.data;
              if (this.goodsDetail.customs) {
                delete this.goodsDetail.customs.gmtCreate;
                delete this.goodsDetail.customs.companyCode;
              }
              this.firstTabData.baseData.basicUnit = this.goodsDetail.basicUnit;
              this.extendList = this.goodsDetail.extendList;
              this.goodsDetail.productDetails.forEach((item) => {
                if (item.detailProductStatus != 'ZT03' && item.detailProductStatus != 'ZT04') {
                  //有不是已生效且不是禁用的子类 全部禁用按钮不可用
                  this.canForbidAllFlag = false;
                }
              });
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          })
          .then(() => {});
      },
      //跳转列表
      returnRouter() {
        let path = {
          fromPath: {
            path: '/masterData/forbidenGoods',
            name: 'forbidenGoods',
            meta: {
              keepAlive: true,
              title: this.$t('goods.title.forbidenGoods'),
            },
          },
          toPath: {
            path: '/masterData/goods',
            name: 'goods',
            meta: {
              keepAlive: false,
              title: this.$t('goods.title.goods'),
            },
            query: {},
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      //禁用或者解除禁用 0启用 1禁用
      updateDetailStatus(val, arr) {
        var params = {
          forbidFlag: val,
        };
        var ids = [];
        arr.forEach((item) => {
          ids.push({
            id: item.id,
            productDetailCode: item.productDetailCode,
            version: item.version,
          });
        });
        params.ids = JSON.stringify(ids);
        this.$axios.post(API.DETAIL_PRODUCT_STATUS_UPDATE, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            //跳转列表
            this.returnRouter();
          } else if (res.data.code === 10000) {
            //强制禁用
            this.$repeatConfirm(
              "<div><img src='/static/img/tips.png'/>" +
                "<div class='repeatContent'>" +
                res.data.msg +
                '</div></div>',
              '',
              {
                dangerouslyUseHTMLString: true,
                confirmButtonText: this.$t('goods.message.forciblyDisable'),
                cancelButtonText: this.$t('confirm.cancel'),
                center: true,
                callback: (action) => {
                  if (action === 'confirm') {
                    params.forceFlag = 0;
                    this.$axios.post(API.DETAIL_PRODUCT_STATUS_UPDATE, params).then((res) => {
                      if (res.data.code === 0) {
                        // this.getData();
                        this.$message({
                          showClose: true,
                          message: res.data.msg,
                          type: 'success',
                        });
                        this.returnRouter();
                      } else {
                        this.$message({ showClose: true, type: 'error', message: res.data.msg });
                      }
                    });
                  } else {
                    this.$message({
                      type: 'info',
                      message: this.$t('logistics.detailsOfCharges.getUpDelete'),
                    });
                  }
                },
              }
            );
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //禁用选中部分
      updateChoosenDetailStatus(arr, val) {
        this.updateDetailStatus(val, arr);
      },
      //禁用全部
      updateAllDetailStatus() {
        this.updateDetailStatus(1, this.goodsDetail.productDetails);
      },
    },
  };
</script>

<style scoped>
  .goodsDetail {
    padding: 10px;
    background-color: #fff;
    margin-bottom: 80px;
  }
</style>
